package org.example.project.dashboard

import androidx.compose.runtime.*
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.coroutines.CancellationException
import kotlinx.coroutines.await
import kotlinx.coroutines.awaitCancellation
import kotlinx.coroutines.ensureActive
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Text
import org.w3c.dom.HTMLElement
import org.w3c.dom.HTMLScriptElement
import kotlin.js.Promise

private var pdfPreviewModule: Promise<Unit>? = null
private const val PDF_PREVIEW_ROOT = "service-document-pdf-preview"

private suspend fun loadPdfPreviewModule() {
    if (window.asDynamic().LumaticaPdfPreview != null) return
    val pending = pdfPreviewModule ?: Promise<Unit> { resolve, reject ->
        val script = document.createElement("script") as HTMLScriptElement
        script.type = "module"
        script.src = "/images/pdf-preview/driver-preview.mjs"
        script.onload = { resolve(Unit); null }
        script.onerror = { _, _, _, _, _ -> reject(IllegalStateException("PDF-Vorschau konnte nicht geladen werden.")); null }
        document.head?.appendChild(script)
    }.also { pdfPreviewModule = it }
    try { pending.await() }
    catch (error: Throwable) { pdfPreviewModule = null; throw error }
}

@Composable
internal fun PdfDocumentPreview(blobUrl: String, title: String) {
    var error by remember(blobUrl) { mutableStateOf(false) }
    LaunchedEffect(blobUrl) {
        var preview: dynamic = null
        try {
            loadPdfPreviewModule()
            ensureActive()
            val root = document.getElementById(PDF_PREVIEW_ROOT) as? HTMLElement
                ?: throw IllegalStateException("PDF preview root missing")
            preview = window.asDynamic().LumaticaPdfPreview.mount(root, blobUrl)
            preview.ready.unsafeCast<Promise<Unit>>().await()
            awaitCancellation()
        } catch (cancelled: CancellationException) {
            throw cancelled
        } catch (failure: Throwable) {
            error = true
            console.error("PDF preview failed", failure)
        } finally {
            if (preview != null) preview.dispose()
        }
    }
    if (error) Div({ style { color(Color("#ff9e9e")) } }) { Text("PDF-Vorschau konnte nicht geöffnet werden.") }
    Div({
        id(PDF_PREVIEW_ROOT)
        attr("role", "document")
        attr("aria-label", title)
        style {
            width(100.percent); flex(1); minHeight(0.px); overflow("auto")
            borderRadius(8.px); backgroundColor(Color("#25272b"))
            padding(12.px); boxSizing("border-box")
            display(DisplayStyle.Flex); flexDirection(FlexDirection.Column); alignItems(AlignItems.Center); gap(12.px)
        }
    })
}
